var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStyleGuideStep = function SvgStyleGuideStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    fill: "currentColor",
    style: {
      color: "#2d4e6d"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.998 0A1.998 1.998 0 0 0 0 1.998v10.667a1.998 1.998 0 0 0 1.998 1.998h8a1.998 1.998 0 0 0 1.998-1.998V3.998a.665.665 0 0 0-.194-.47L8.469.195A.665.665 0 0 0 7.999 0H1.997Zm5.999 1.604L10.393 4H8.665a.668.668 0 0 1-.668-.668V1.604Zm-1.33 1.728V1.33H1.998a.668.668 0 0 0-.668.668v10.667a.668.668 0 0 0 .668.668h8a.668.668 0 0 0 .668-.668V5.33H8.666a1.998 1.998 0 0 1-1.998-1.998Z",
    clipRule: "evenodd"
  })));
};
export default SvgStyleGuideStep;